@use "Styles/mixins" as mixins;
@use "Styles/includes/variables";

:host {
    display: block;
    visibility: visible;

    .teaser-message-wrap {
        display: flex;
        align-items: center;
        gap: 20px;
        height: 34px;
    }

    .teaser-message-avatar {
        width: 34px;
        height: 34px;
        border-radius: 100%;
        background: linear-gradient(93deg, mixins.get-color(teal, 500) 0%, mixins.get-color(teal, 600) 100%);
        overflow: hidden;
    }

    .teaser-message-text {
        font-family: variables.$fontQuaternary;
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        letter-spacing: 0.07px;
        color: mixins.get-color(neutral, 700);
    }

    .lines-wrap {
        margin: 24px 0 0 0;
    }

    .line {
        @keyframes shimmer {
            0% {
                background-position: 200% 0;
            }
            100% {
                background-position: -200% 0;
            }
        }

        &:nth-child(4n + 1) {
            width: 78%;
            height: 20px;
            border-radius: 30px;
            background: linear-gradient(
                90deg,
                mixins.get-color(teal, 100) 0%,
                mixins.get-color(teal, 50) 20%,
                mixins.get-color(teal, 100) 40%,
                mixins.get-color(teal, 50) 60%,
                mixins.get-color(teal, 100) 80%
            );
            background-size: 200% 100%;
            animation: shimmer 3s infinite linear;

            &:not(:first-child) {
                margin: 24px 0 0;
            }
        }

        &:nth-child(4n + 2),
        &:nth-child(4n + 3) {
            width: 100%;
            height: 14px;
            border-radius: 30px;
            background: linear-gradient(
                90deg,
                mixins.get-color(teal, 100) 0%,
                mixins.get-color(teal, 50) 20%,
                mixins.get-color(teal, 100) 40%,
                mixins.get-color(teal, 50) 60%,
                mixins.get-color(teal, 100) 80%
            );
            background-size: 200% 100%;
            animation: shimmer 3s infinite linear;
            margin: 11px 0 0;
        }

        &:nth-child(4n) {
            width: 56%;
            height: 14px;
            border-radius: 30px;
            background: linear-gradient(
                90deg,
                mixins.get-color(teal, 100) 0%,
                mixins.get-color(teal, 50) 20%,
                mixins.get-color(teal, 100) 40%,
                mixins.get-color(teal, 50) 60%,
                mixins.get-color(teal, 100) 80%
            );
            background-size: 200% 100%;
            animation: shimmer 3s infinite linear;
            margin: 14px 0 0;
        }
    }
}

:host([data-type="inline"]) {
    .teaser-message-wrap {
        gap: 8px;
    }
}

:host([data-hidden]) {
    display: none;
    visibility: hidden;
}
